import "moment-timezone";
import moment from "moment";

const ModalFirmwareTable = ({itemsShown, setItem}) => {
    const onClickRadio = (e) => {
        setItem({...itemsShown[parseInt(e.target.value)]});
    };

    return itemsShown.length === 0 ? (
        <div className="alert alert-secondary text-center">No existen firmwares para este modelo.</div>
    ) : (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th></th>
                    <th style={{width: "135px"}}>Fecha</th>
                    <th>Name</th>
                    <th>Version</th>
                    <th>Tamaño</th>
                </tr>
            </thead>
            <tbody>
                {itemsShown.map((item, index) => (
                    <tr key={index} data-idx={index}>
                        <td className="align-middle">
                            <input type="radio" name="radio-asset" value={index} onClick={onClickRadio} />
                        </td>
                        <td>
                            <span>{moment(item.create_at).format("DD-MM-YYYY HH:mm")}</span>
                        </td>
                        <td>{item.name}</td>
                        <td>{item.version}</td>
                        <td>{item.size}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ModalFirmwareTable;
